// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toast-fade-enter-active[data-v-30664c5c],.toast-fade-leave-active[data-v-30664c5c]{transition:opacity .2s ease,transform .2s ease}.toast-fade-enter[data-v-30664c5c],.toast-fade-leave-to[data-v-30664c5c]{opacity:0;transform:translateY(-.5rem)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
